import React, { Component } from 'react'
import Chart from "chart.js";
import { connect } from 'react-redux';
import { actionCreators as scraperDetailActionCreators } from '../../store/ScraperDetailStore';
import CircularProgress from '@material-ui/core/CircularProgress';
import { lighten, makeStyles } from '@material-ui/core/styles';
import { draw, generate } from 'patternomaly'

function groupByGetter(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

class ScraperOverTimeChart extends Component {

    constructor(props) {
        super(props)
        this.chartRef = React.createRef();
        this.updateChart = this.updateChart.bind(this);
        this.chart = null;
    }

    classes = makeStyles(theme => ({
        progress: {
            margin: theme.spacing(2),
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'block'
        },
    }));

    groupBy() {
        return function (xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };
    }

    getGroups(data, propertyName) {
        let grouped = this.groupBy()(data, propertyName);
        let asArray = Object.keys(grouped).map(function (key) {
            return [key, grouped[key]];
        });

        return asArray.sort(function (a, b) {
            return a > b;
        });
    }

    updateChart() {
        const scraperOverTimeChartRef = this.chartRef.current.getContext("2d");

        let data = this.props.data.map(d => {
            return {
                x: d['dateTime'].slice(0, 10),
                y: d['count'],
                z: d['caseCount'],
            }
        })

        //let data = Array.from(groupByGetter(this.props.data, e => {
        //    let theDate = new Date(e[this.props.dateField]);

        //    theDate.setHours(0);
        //    theDate.setMinutes(0);
        //    theDate.setSeconds(0);
        //    theDate.setMilliseconds(0);

        //    return theDate.toISOString().slice(0, 10);
        //})).map(e => {
        //    return {
        //        x: e[0],
        //        y: e[1].length,
        //        items: e[1]
        //    }
        //});
            
        let caseData = data.map(d => {
            return {
                x: d.x,
                y: d.z
            }
        });

        var N = 100;
        let colors = Array.apply(null, { length: N }).map(() => draw('square', '#455368'));
        
        if (this.chart) this.chart.destroy();
        this.chart = new Chart(scraperOverTimeChartRef, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: "Records",
                        data,
                        //color: "rgba(69, 83, 104, .5)"
                        backgroundColor: "rgba(69, 83, 104, 1)",//"#455368",//"rgba(69, 83, 104, .5)",//"#455368",
                    },
                    //{
                    //    label: "Cases",
                    //    data: caseData,
                    //    backgroundColor: "rgba(69, 83, 104, .5)",//"#455368",
                    //}
                ]
            },
            options: {
                animation: false,
                scales: {
                    bounds: 'ticks',
                    ticks: {
                        source: 'data'
                    },
                    xAxes: [{
                        source: 'auto',
                        type: 'time',
                        time: {
                            unit: 'day',
                            unitStepSize: 3,
                            displayFormats: {
                                day: 'MMM DD' //MMM D
                            },
                        },
                        //distribution: 'series'
                    }],
                    //yAxes: [{
                    //    scaleLabel: {
                    //        display: true,
                    //        labelString: ''
                    //    }
                    //}]
                }
            }
        });

        this.updateHandlers();
    }

    updateHandlers() {
        //this.chartRef.current.onclick = evt => {
        //    let element = this.chart.getElementsAtEvent(evt)[0];
        //    if (element && element._model && element._model.label)
        //        this.props.showDetailPane(element._model.label, <div></div>);
        //}
    }

    componentWillUnmount() {
        //this.chartRef.destroy();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data != this.props.data) {
            this.updateChart();
        }
        if (prevProps.showDetailPane != this.props.showDetailPane) {
            this.updateHandlers();
        }
    }
    componentDidMount() {
        if (this.props.data && this.props.data.length)
            this.updateChart();
    }
    render() {
        return (
            <div style={{paddingLeft: 5, paddingRight: 5}}>
                <canvas
                    id="scraperOverTimeChart"
                    ref={this.chartRef}
                    style={{ display: this.props.isLoading ? 'none' : 'block' }}
                />
                <CircularProgress className={this.classes.progress} style={{ display: this.props.isLoading ? 'block' : 'none' }} />
            </div>
        )
    }
}

//export default connect()(ScraperOverTimeChart);
export default connect(state => {
    return {
        ...(state.scraperDetail)
    }
},
    {
        requestScraperDetail: scraperDetailActionCreators.requestScraperDetail
    },(propsFromState, propsFromDispatch, ownProps) => {
        return {
            ...propsFromState,
            ...propsFromDispatch,
            ...ownProps
    }
})(ScraperOverTimeChart);